import { Card, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Box, CardActions, CardContent, Stack, type SxProps, type Theme } from "@mui/material";
import { type ReactNode } from "react";

import { IconButton } from "../components/IconButton";

export interface ChatActionCardProps {
  pill?: React.ReactNode;
  message: string;
  children?: ReactNode;
  onClose?: () => void;
  sx?: SxProps<Theme>;
}

export function ChatActionCard(props: ChatActionCardProps) {
  const { pill, message, children, onClose, sx } = props;
  return (
    <Card outlined variant="tertiary" sx={sx}>
      <CardContent
        sx={(theme) => ({
          paddingX: theme.spacing(5),
          paddingTop: theme.spacing(5),
          paddingBottom: 0,
        })}
      >
        <Stack spacing={5}>
          <Box display="flex" justifyContent="space-between">
            {pill}
            {onClose && (
              <IconButton iconType="close" variant="outlined" size="xSmall" onClick={onClose} />
            )}
          </Box>
          <Text>{message}</Text>
        </Stack>
      </CardContent>
      {isDefined(children) && (
        <CardActions
          sx={(theme) => ({
            paddingX: theme.spacing(5),
            paddingTop: theme.spacing(7),
            paddingBottom: theme.spacing(5),
          })}
        >
          {children}
        </CardActions>
      )}
    </Card>
  );
}
